<!-- eslint-disable no-unused-vars -->
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Multiselect from 'vue-multiselect'
import RestEditableTable from '@/components/RestEditableTable'
import { GET_DEVICE_CODE } from '@/services/api/master/tracking'
import { GET_COMPANYS } from '@/services/api/master/companies'
import { getToolsClient } from '@/services/tools'
import McButton from '@/components/McButton'

const toolsAxios = getToolsClient()

export default {
  page: {
    title: 'Bulk Online Command',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    Layout,
    McButton,
    PageHeader,
    Multiselect,
    RestEditableTable,
  },

  apollo: {
    deviceTypes: {
      query: GET_DEVICE_CODE,
    },
    companies: {
      query: GET_COMPANYS,
    },
  },

  data() {
    return {
      filters: {
        device: '',
        company: '',
      },
      deviceTypes: {
        deviceType: [],
      },
      companies: {
        companies: [],
      },
      selectedDevices: [],
      selectedDevicesTemporary: [],
      checkedImeis: [],
      inputCommand: '',
      debounceTimer: null,
      isTabDomain: true,
      tabItemInput: {
        byDomain: [],
        byImei: '',
      },
      isLoadingTable: false,
      isRepeatedProcess: false,
      isAllSuccessfull: null,
      statusLists: {
        200: 'Terkirim',
        unregistered: 'Tidak Terdaftar',
        failed: 'Gagal',
        loading: 'loading',
      },
    }
  },

  watch: {
    'filters.company'(newVal, oldVal) {
      if (!newVal || !oldVal) return
      this.checkedImeis = []
      this.$refs['modalFilterImeiRef'].selectedAll = false
      this.$refs['modalFilterImeiRef'].selectedIds = []
      this.$refs['modalFilterImeiRef'].selectedIdsLength = 0
    },
  },

  computed: {
    title() {
      return 'Bulk Online Command'
    },

    fields() {
      return [
        {
          key: 'imei',
          thClass: 'mc-table--170',
          label: 'IMEI',
          type: 'text',
        },
        {
          key: 'deviceType',
          thClass: 'mc-table--170',
          label: this.$t('task.column.deviceType'),
          type: 'text',
          trackBy: 'deviceName',
          customLabelFn: (item, key = 'deviceType') => `${item[key].deviceName}`,
        },
        {
          key: 'status',
          thClass: 'mc-table--170',
          label: 'Status',
          type: 'text',
        },
      ]
    },

    apiClient() {
      return {
        get: this.queries.get,
      }
    },

    queries() {
      return {
        get: async (param) => {
          let payload = {
            filters: `imei:eq:${param.q ?? ''}`,
          }
          if (param.companyName || param.deviceName) {
            payload = {
              filters: `companyName:like:${param.companyName ?? "''"};deviceName:like:${
                param.deviceName ?? ''
              }`,
              page: param.page ?? 1,
              size: param.size ?? 10,
            }
          }
          const response = await toolsAxios.get('/device', { params: payload })
          response.data.data?.forEach((val) => {
            val['can_delete'] = true
          })
          return response?.data
        },
      }
    },
  },

  async beforeRouteLeave(to, from, next) {
    const confirm = window.confirm(this.$t('qcdevice.bulkOnlineCommand.leaveSiteMessage'))
    if (confirm) {
      next()
    } else {
      window.onbeforeunload = function () {
        return this.$t('qcdevice.bulkOnlineCommand.leaveSiteMessage')
      }
      next(false)
    }
  },

  methods: {
    handleAddBulkEdit() {
      this.$bvModal.show('bulkCommandModal')
      this.isLoadingTable = true
      if (!this.isAllSuccessfull) return
      this.isRepeatedProcess = true
      this.selectedDevices = this.selectedDevices ?? []
      this.filters = {}
      this.$refs['modalFilterImeiRef'].items = []
      this.$refs['modalFilterImeiRef'].selectedIds = {}
      this.$refs['modalFilterImeiRef'].selectedIdsLength = 0
      this.$refs['modalFilterImeiRef'].selectedAll = false
    },

    async handleCommandsPayload(event, payloads) {
      const imeiData = payloads ?? this.selectedDevices
      if (!imeiData?.length) return

      const concurrency = 10 // cap concurrent command dispatches to avoid browser resource limits

      const processItem = async (data, idx) => {
        try {
          const payload = {
            imei: data.imei,
            command: this.inputCommand,
            device_code: data.deviceCode ?? null,
            online_command: 'custom_command',
            vehicle_id: data.vehicle ? data.vehicle.vehicle_id : null,
          }

          this.selectedDevices.splice(idx, 1, {
            ...data,
            statusSendCommand: this.statusLists.loading,
          })

          const result = await this.sendCommands(payload)

          if (!result || result?.status === 'failed') {
            this.selectedDevices.splice(idx, 1, {
              ...data,
              statusSendCommand: this.statusLists.failed,
            })
            return
          }

          this.selectedDevices.splice(idx, 1, {
            ...data,
            statusSendCommand: this.statusLists[result?.status],
          })
        } catch (error) {
          this.selectedDevices.splice(idx, 1, {
            ...data,
            statusSendCommand: this.statusLists.failed,
          })
          console.error(error)
        }
      }

      // send commands in batches to limit concurrent HTTP connections
      for (let i = 0; i < imeiData.length; i += concurrency) {
        const batch = imeiData.slice(i, i + concurrency)
        await Promise.all(batch.map((data, batchIdx) => processItem(data, i + batchIdx)))
      }

      this.reset()
    },

    reset() {
      this.filters = {}
      this.inputCommand = ''
      this.tabItemInput = {}
      this.isAllSuccessfull = true
      this.isRepeatedProcess = false
    },

    async sendCommands(payload) {
      if (!payload || !payload?.vehicle_id || !payload?.device_code || !payload?.imei) return
      try {
        let res = await toolsAxios({
          method: 'POST',
          url: '/command/custom_command',
          data: payload,
        })
        return res
      } catch (error) {
        console.log(error)

        return { status: 'failed' }
      }
    },

    async handleOk() {
      this.$bvModal.hide('bulkCommandModal')
      this.selectedDevices = this.tabItemInput.byDomain ?? this.selectedDevices
      this.isLoadingTable = false
      if (this.isTabDomain) return

      const imeis = [
        ...new Set(
          this.tabItemInput?.byImei
            .split(',')
            .map((item) => item.trim())
            .filter((item) => item !== '')
        ),
      ]

      /*get the most updated list of imei (s)*/
      if (this.selectedDevices?.length > 0)
        this.selectedDevices = this.selectedDevices.filter((item) => imeis.includes(item.imei))

      this.getDataForMainTable(imeis)
    },

    async getDataForMainTable(imeis) {
      // guard against empty or undefined input
      if (!imeis?.length) return

      this.isLoadingTable = true

      const concurrency = 10 // cap concurrent requests to avoid browser resource limits

      const fetchDevice = async (imei) => {
        try {
          const response = await this.queries.get({ q: imei })
          let [data] = response.data.length > 0 ? response.data : []

          if (response.data.length === 0) {
            data = { imei, deviceType: '-', statusSendCommand: this.statusLists.unregistered }
          } else {
            data['deviceType'] = data.deviceType?.deviceName
            data['statusSendCommand'] = '-'
          }

          if (!this.selectedDevices?.find((e) => e.imei === data.imei)) {
            this.selectedDevices?.push(data)
          }
        } catch (error) {
          // keep processing other IMEIs even if one request fails
          console.log(error)
        }
      }

      // simple pool to control the amount of concurrent HTTP requests
      for (let i = 0; i < imeis.length; i += concurrency) {
        const batch = imeis.slice(i, i + concurrency)
        await Promise.all(batch.map((imei) => fetchDevice(imei)))
      }

      this.isLoadingTable = false
    },

    cancelModal() {
      this.$bvModal.hide('bulkCommandModal')
      this.tabItemInput = {}
      this.isLoadingTable = false
    },

    customLabelDevice(item) {
      if (item.deviceName) return `${item.deviceName}`
    },

    customLabel(item) {
      return `${item.name} (${item.domainName})`
    },

    async handleCheckedItems(item) {
      this.checkedImeis = Object.keys(item).filter((key) => item[key] === true)
      const devices = this.$refs['modalFilterImeiRef']?.items
      this.selectedDevicesTemporary = [...this.selectedDevicesTemporary, ...devices]
      this.tabItemInput.byDomain = this.selectedDevicesTemporary.filter((e) =>
        this.checkedImeis.includes(e.imei)
      )
      this.selectedDevicesTemporary = this.tabItemInput.byDomain
      this.tabItemInput.byDomain.forEach((e) => (e['statusSendCommand'] = '-'))
      this.isLoadingTable = false
    },

    clearAll() {
      this.selectedDevices = []
      this.tabItemInput.byImei = ''
    },
  },
}
</script>
<style>
.mc-editable-table .row.justify-content-end {
  display: block;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" />
    <p class="mb-4">{{ $t('qcdevice.bulkOnlineCommand.description') }}</p>
    <div class="clearfix mc-btn-group__list">
      <div class="float-end">
        <b-button
          @click="$router.push({ name: 'QC Device' })"
          variant="outline-primary"
          menu-class="dropdown-menu-end"
          class="ms-3"
        >
          <i class="bx bx-arrow-back"></i> {{ $t('global.back') }}
        </b-button>
      </div>
    </div>

    <div class="justify-content-end gap-2 d-flex mb-3">
      <McButton
        v-if="isAllSuccessfull"
        variant="secondary"
        :disabled="selectedDevices.some((e) => e.statusSendCommand === 'loading')"
        id="mc-add-btn"
        text="Ubah Command"
        icon="icon-outline_edit"
        @click="() => (this.isRepeatedProcess = true)"
      />
      <McButton
        variant="primary"
        :disabled="
          selectedDevices?.length === 0 ||
          inputCommand === '' ||
          this.selectedDevices.some((e) => e.statusSendCommand === 'loading')
        "
        id="mc-add-btn"
        text="Kirim"
        icon="bx bx-navigation"
        iconPosition="right"
        @click="handleCommandsPayload"
      />
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row align-items-baseline mb-4">
          <div class="col-2 me-n5">
            <label class="align-self-center fw-bold"
              >Online Command <span class="text-danger">*</span></label
            >
          </div>
          <FormulateInput
            type="text"
            v-model="inputCommand"
            placeholder="Masukkan custom online command"
            validation="required"
            :validation-messages="{
              required: `Wajib Diisi`,
            }"
            validation-behavior="submit"
            error-behavior="submit"
            class="col-4 me-4"
            :disabled="
              (isAllSuccessfull && !isRepeatedProcess) ||
              selectedDevices.some((e) => e.statusSendCommand === 'loading')
            "
          />
        </div>

        <div class="ml-auto d-flex justify-content-between mb-3">
          <label class="fw-bold p-0 align-self-end">Daftar Device</label>
          <McButton
            variant="primary"
            id="mc-add-btn"
            text="Tambah"
            icon="icon-fill_plus"
            @click="handleAddBulkEdit"
          />
        </div>

        <div class="table-responsive my-3 border border-1 mc-table-overflow">
          <b-table
            ref="mainBulkTableRef"
            :items="selectedDevices"
            :fields="fields"
            show-empty
            :empty-text="$t('global.emptyTable')"
            :busy="isLoadingTable"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(status)="data">
              <div class="text-danger my-2" v-if="data.item.statusSendCommand === 'loading'">
                <b-spinner class="align-middle"></b-spinner>
              </div>
              <div v-else>
                {{ data.item.statusSendCommand }}
              </div>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                {{ $t('show') }}&nbsp;<strong>{{ selectedDevices.length > 0 ? 1 : 0 }}</strong>
                &nbsp;{{ $t('to') }}&nbsp;<strong>{{ selectedDevices.length }}</strong> &nbsp;{{
                  $t('from')
                }}&nbsp;<strong>{{ selectedDevices.length }}</strong
                >&nbsp;{{ $t('entry') }}.
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  :value="1"
                  :total-rows="selectedDevices.length"
                  :per-page="selectedDevices.length"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      header-bg-variant="primary"
      modal-class="mc-bulk-command__filter"
      id="bulkCommandModal"
      title="Set Online Command"
      size="lg"
      centered
      scrollable
      static
      no-close-on-esc
      no-close-on-backdrop
      @close="cancelModal"
    >
      <b-card class="mb-n2">
        <b-tabs>
          <b-tab title="Filter by Domain" active @click="() => (isTabDomain = true)">
            <div class="mc-report__filter-wrapper">
              <b-row class="pt-2">
                <b-form-group label="Domain" class="col-6">
                  <multiselect
                    v-model="filters.company"
                    :options="companies.companies"
                    placeholder="Pilih Company"
                    :allow-empty="false"
                    :custom-label="customLabel"
                  />
                </b-form-group>
                <b-form-group label="Tipe Perangkat" class="col-6">
                  <multiselect
                    ref="deviceTypeRef"
                    v-model="filters.device"
                    :options="deviceTypes.deviceType"
                    label="deviceName"
                    placeholder="Tipe Perangkat"
                    :allow-empty="true"
                    :custom-label="customLabelDevice"
                  />
                </b-form-group>
              </b-row>
              <RestEditableTable
                ref="modalFilterImeiRef"
                :fields="fields.filter((e) => e.key !== 'status')"
                trackBy="imei"
                :enableAddButton="false"
                :apiClient="queries"
                :customFilters="{
                  deviceName: filters?.device?.deviceName,
                  companyName: filters?.company?.name,
                }"
                @selectedIdsChange="handleCheckedItems"
                :showNoData="true"
                :enableDeleteButton="false"
                :enableCheckbox="true"
              />
            </div>
          </b-tab>
          <b-tab title="Input IMEI" @click="() => (isTabDomain = false)">
            <div class="mc-report__filter-wrapper">
              <b-row class="py-2 mb-2">
                <b-form-group>
                  <b-form-textarea
                    v-model="tabItemInput.byImei"
                    placeholder="Ketik IMEI"
                    rows="15"
                    class="mt-2"
                  ></b-form-textarea>
                </b-form-group>
                <div class="d-flex justify-content-start gap-2">
                  <i class="icon-outline_info float-end pt-2"></i>
                  <h6 class="pt-2 text-muted">
                    Gunakan separator koma (,) untuk input IMEI lebih dari 1
                  </h6>
                </div>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
      <template #modal-footer="{ cancel }">
        <div class="d-flex justify-content-end mx-4">
          <b-button variant="outline-primary" @click="cancelModal()" class="me-3"> Batal </b-button>
          <b-button variant="primary" @click="handleOk"> Simpan </b-button>
        </div>
      </template>
    </b-modal>
  </Layout>
</template>
